if ( null !== document.querySelector('.search-box .inner-search-icon') ) {

	document.querySelector('.search-box .inner-search-icon').onclick = (e) => {
		e.currentTarget.parentNode.querySelector('form').submit();
	}

}


// WEBPACK FOOTER //
// ./assets/js/components/layout/search-box.js